import React from "react";
import { Col, Row } from "react-bootstrap";
import linux from "../../Assets/TechIcons/linux.svg";
import vim from "../../Assets/TechIcons/vim.svg";
import vsCode from "../../Assets/TechIcons/vscode.svg";
import androidstudio from "../../Assets/TechIcons/androidstudio.svg";

const rowStyle = { justifyContent: "center", paddingBottom: "50px" };

const TOOL_STACK = [
  { icon: linux, alt: "linux", label: "Linux" },
  { icon: vim, alt: "vim", label: "Vim" },
  { icon: vsCode, alt: "vsCode", label: "Vs Code" },
  { icon: androidstudio, alt: "androidstudio", label: "Android Studio" },
];

function Toolstack() {
  return (
    <Row style={rowStyle}>
      {TOOL_STACK.map(({ icon, alt, label }) => (
        <Col xs={4} md={2} className="tech-icons" key={label}>
          <img src={icon} alt={alt} className="tech-icon-images" />
          <div className="tech-icons-text">{label}</div>
        </Col>
      ))}
    </Row>
  );
}

export default React.memo(Toolstack);
